export default "<p>goto works!</p>\n";